<div class="modal-header">
    <h4 class="modal-title pull-left">{{(IsEditMode ? "Edit " : "Add ") + marketingType?.description}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="onClose($event)">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="form-group" *ngIf="!hideSource">
        <label class="form-label">Source</label>
        <label class="select">
            <select [(ngModel)]="currentData.SourceId" class="form-control">
                <option [ngValue]="null">Select</option>
                <option *ngFor="let source of sourcelist" [(ngValue)]="source.Id">{{source.Source}}</option>
            </select>
            <i></i>
        </label>
    </div>
    <div class="form-group">
        <label class="form-label">Start Date<span class="star">*</span></label>
        <div class="textbox-date">
            <input type="text" maxlength="10" name="txtFromDate" #FromDate="ngModel" autocomplete="off" [(ngModel)]="this.fromDate" (ngModelChange)="changeDate();" required="required" class="form-control" bsDatepicker>
            <i class="icofont icofont-ui-calendar icon"></i>
            <p class="redtext" *ngIf="(_validationService.IsinValid(this.fromDate) && isSubmit) ||(FromDate.invalid && FromDate.touched)">From Date is required </p>
        </div>
    </div>
    <!--<!--<div class="form-group">
        <label class="form-label">To Date<span class="star">*</span></label>
        <div class="textbox-date">
            <input type="text" maxlength="10" name="txtToDate" #toDate="ngModel" autocomplete="off" [(ngModel)]="currentData.ToDate" (ngModelChange)="validateToDate();" required="required" class="form-control" bsDatepicker>
            <i class="icofont icofont-ui-calendar icon"></i>
            <p class="redtext" *ngIf="(_validationService.IsinValid(currentData.ToDate) && isSubmit) ||(toDate.invalid && toDate.touched)">To Date is required </p>
        </div>
    </div>-->
    <div class="form-group">
        <label class="form-label">{{marketingType?.description}}<span class="star">*</span></label>
        <div class="textbox-with-btn-left">
            <input placeholder="{{marketingType?.description}}" class="form-control" #Value="ngModel" dropSpecialCharacters="false" currencyMask  [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }"  [(ngModel)]="currentData.Value" maxlength="15"
                   value="{{currentData.Value | number}}">
        </div>
        <p class="redtext" *ngIf="(_validationService.IsinValid(currentData.Value) && isSubmit) ||(Value.invalid && Value.touched)">{{marketingType?.description}} is required </p>
    </div>
    <div class="form-group">
        <div class="text-right">
            <button type="button" (click)="onClose($event)" class="btn btn-default btn-lg">Cancel</button>
            <button type="button" (click)="saveDetails()" [disabled]="isSubmit" class="btn btn-success btn-lg">Save</button>
        </div>

    </div>
</div>
